<template src="./html/Edit.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	//import Buttons from './Buttons.vue'
	import Products from '../../productStorages/views/Products.vue'
	import productStorages from '../../productStorages/layout/productStorages.vue'
	import Navbar from './Navbar'

	export default {
		props: ['user', 'isAuth'],
		components: {
			//'buttons': Buttons,
			'products': Products,
			'product-storages': productStorages,
			'navbar': Navbar,
		},
		data () {
			return {
				modal: {
					selector: 'product-create',
				},
				dropzone: {
					accepted: this.$env.ACCEPTED_DROPZONE_DOCS,
					url: process.env.ROOT + '/api/' + this.$lang.getLang() + '/admin',
				},
				item: null,
				loading: false,
				currencies: null,

				prefix: null,
				number_invoice_provider: null,
				reference: null,
				number: null,

				editModeNumber: false,
				date: null,
			}
		},
		created() {
			this.init()
		},
		methods: {
			init() {
				this.getData()
				this.getCurrencies()
			},
			reload() {
				this.getData()
			},
			getCurrencies: function() {
				this.$http.get('admin/cms/currencies')
					.then(response => {
						this.currencies = response.body
					})
			},
			getData () {
				var id = this.$route.params.id
				if(id) {
					this.$http.get('admin/management/invoices/' + id + '/edit')
						.then(response => {
							this.item = response.body
							this.prefix = this.item.prefix
							this.number_invoice_provider = this.item.number_invoice_provider
							this.reference = this.item.reference
							this.number = this.item.number
							this.date = moment(this.item.created_at).toISOString()
							$('#table-products tbody tr').removeClass('disabled')
							$('#table-products tbody tr td input').attr('disabled', false)
						}).catch(response => {
							$('#table-products tbody tr').removeClass('disabled')
							$('#table-products tbody tr td input').attr('disabled', false)
							if (response.status == 409) {
								swal({
									title: response.body.title,
									text: response.body.text,
									type: response.body.type,
								})
							} else {
								swal({
									title: response.statusText,
									text: response.body,
									type: 'warning',
								})
							}
						})
				}
			},
			editProduct(product) {
				this.$refs.productStorages.editProduct(product)
			},
			destroyProduct(product) {
				var that = this

				swal.queue([{
					title: that.$t("messages.attention"),
					text: that.$t("messages.item_can_not_be_retrieved"),
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.delete('admin/management/products/storages/' + product.id)
							.then(response => {
								let index = that.item.products.indexOf(product)
								that.item.products.splice(index, 1)
								that.getData()
								swal(response.body.title, response.body.text, response.body.type);
							}).catch(function(response) {
								swal({
									title: response.statusText,
									text: response.body,
									type: "warning"
								});
							})
						})
					}
				}]).catch(swal.noop)
			},
			changeCurrency(el) {
				var select = el.currentTarget
				select.setAttribute('disabled', true)
				this.loading = true
				if(this.item.currency_id) {
					this.$http.get('admin/management/invoices/' + this.item.id + '/change/currency/' + this.item.currency_id)
						.then(response => {
							this.loading = false
							select.removeAttribute('disabled')
							this.getData()
						}).catch(response => {
							this.loading = false
							select.removeAttribute('disabled')
							if(response.status == 409) {
								swal({
									title: response.statusText,
									text: response.body,
									type: 'warning',
								})
							}
							this.getData()
						})
				}
			},
			changeStatus(el) {
				var select = el.currentTarget
				select.setAttribute('disabled', true)
				this.loading = true
				if(this.item.status.id) {
					this.$http.get('admin/management/budgets/' + this.item.id + '/change/status/' + this.item.status.id)
						.then(response => {
							this.loading = false
							select.removeAttribute('disabled')
							this.getData()
						}).catch(response => {
							this.loading = false
							select.removeAttribute('disabled')
							if(response.status == 409) {
								swal({
									title: response.statusText,
									text: response.body,
									type: 'warning',
								})
							}
							this.getData()
						})
				}
			},
			changeNumber() {
				var that = this
				var loading = Ladda.create(this.$refs.btnNumber)
				loading.start()
				var data = {
					prefix: this.prefix,
					number_invoice_provider: this.number_invoice_provider,
					reference: this.reference,
					number: this.number,
				}
				this.$http.put('admin/management/invoices/' + this.item.id + '/update', data)
				.then(response => {
					loading.stop()
					this.editModeNumber = false
					this.reload()
					swal({
						title: response.body.title,
						text: response.body.text,
						type: response.body.type
					})
				}).catch(function(response) {
					console.log(response)
					this.editModeNumber = false
					loading.stop()
					this.reload()
					if(response.status == 409) {
						swal({
							title: response.body.title,
							text: response.body.text,
							type: response.body.type
						})
					}
				})
			},
			updateDate() {
				var that = this
				var data = {
					created_at: moment(this.date).format('YYYY-MM-DD HH:mm:ss'),
				}
				if(this.item.created_at != data.created_at) {
					this.$http.put('admin/management/invoices/' + this.item.id + '/update', data)
					.then(response => {
						this.reload()
					}).catch(function(response) {
						console.log(response)
						this.reload()
						if(response.status == 409) {
							swal({
								title: response.body.title,
								text: response.body.text,
								type: response.body.type
							})
						}
					})
				}
			}
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/management/invoices/views/Edit.vue